import React from 'react'
import './trustedBy.css'
export default function TrustedBy() {
  return (
    <div className='trusted-container'>
        <div className="trusted-header">
            <h3>Trusted By Innovators,<span> Professionals</span>, and Industry Leaders</h3>
            <p>Join Thousands of Happy Users, Pioneers and Professionals</p>
        </div>
        <div className="companies-logo">
            <img src="assets/techstarlogo-removebg-preview.png" alt="" />
            <img src="assets/Slack_Technologies_Logo.svg-removebg-preview.png" alt="" />
            <img src="assets/PayPal-Logo-removebg-preview.png" alt="" />
            <img src="assets/Western-Union-Logo-removebg-preview.png" alt="" />
            <img src="assets/ylogo-removebg-preview.png" alt="" />
        </div>
    </div>
  )
}
